import { render, staticRenderFns } from "./AssignTask.vue?vue&type=template&id=4c29e1d2&"
import script from "./AssignTask.vue?vue&type=script&lang=js&"
export * from "./AssignTask.vue?vue&type=script&lang=js&"
import style0 from "./AssignTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports